module.exports = __webpack_public_path__ + "img/benjike6.f8ed613d.png";